import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import { clearFormInput } from 'actions/FormActions';
import "../styles/MultiStoreInvSearch.css";

class MultiStoreSearch extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur();
            this.props.onSearch(e.target.value);
        }
    }

    render() {
        const p = this.props;
        const { name, ...textProps } = { ...p };

        return (
            <div>
                <TextInput
                    hintstyle={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                    floatingLabelFocusStyle={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                    floatingLabelShrinkStyle={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", letterSpacing: "-0.25px" }}
                    id="multi-store-search"
                    name={name}
                    {...textProps}
                    onKeyPress={this.onSearchKeyPress}
                />
                <div className="text-right">
                    <Button
                        className="btnNewBrandPOS mr-1"
                        type="IconInButton"
                        name={`${name}Button`}
                        label="SEARCH"
                        onTouchTap={() => p.onSearch(p.searchText)}
                    />
                    <Button
                        type="IconClearButton"
                        name={`${name}Clear`}
                        label="CLEAR"
                        labelStyle={{ color: "white" }}
                        backgroundColor="Grey"
                        onTouchTap={() => this.props.onClear()}
                    />
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        searchText: state.form[`${ownProps.name}SearchText`]
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiStoreSearch);